import {IFormElement} from "../../../../formability/form_builder/models/formElements/formElement";
import {FormElementType} from "../../../enums/formElementType";
import OriginWrapperLookupField from "~/models/mapping/originWrapperLookupField";
import OriginWrapperFormElement from "~/models/mapping/originWrapperFormElement";

export default class OriginWrapperFormElementHelper {
  static build(formElement: IFormElement): OriginWrapperLookupField | OriginWrapperFormElement {
    switch (formElement.element_type) {
      case FormElementType.lookupField:
        return new OriginWrapperLookupField(formElement)
      default:
        return new OriginWrapperFormElement(formElement)
    }
  }
}